<script setup lang="ts">
defineProps({ blok: Object });

const localePath = useLocalePath();
</script>

<template>
  <section class="bg-chsc-indigo-soft py-44 overflow-hidden">
    <UiContainer max-width="max-w-3xl" class="relative">
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/326x333/d15bbcecac/home-supply-01.svg"
        class="absolute -top-20 -left-52 z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/184x189/42aad9b729/home-supply-02.svg"
        class="absolute -top-44 left-32 z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/138x142/deff8d5d82/home-supply-03.svg"
        class="absolute -top-20 left-[600px] z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/310x318/99a9b05739/home-supply-04.svg"
        class="absolute -top-10 left-[800px] z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/248x253/12266fa647/home-supply-05.svg"
        class="absolute top-32 left-[850px] z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/214x218/122f617abf/home-supply-06.svg"
        class="absolute -bottom-44 left-[600px] z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/178x389/6c9d0c3062/home-supply-07.svg"
        class="absolute -bottom-44 left-1/2 -translate-x-1/2 z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/184x189/eeedfea30f/home-supply-08.svg"
        class="absolute -bottom-34 left-[100px] -translate-x-1/2 z-0"
      />
      <img
        v-motion-fade-visible-once
        src="https://a.storyblok.com/f/291812700015950/259x265/b09fc1773f/home-supply-09.svg"
        class="absolute -bottom-32 left-[-200px] -translate-x-1/2 z-0"
      />
      <header class="relative mb-20 home-supply-chain">
        <StoryblokRichText :doc="blok?.header" />
      </header>
      <div class="relative flex justify-center mt-10">
        <UButton :to="localePath('/the-supply-chain')" :label="blok?.cta" size="xl" />
      </div>
    </UiContainer>
    <!-- <UiContainer>
            <div class="grid grid-cols-12 ">
                <StoryblokComponent
                    v-for="item in blok?.issues"
                    :key="item._uid"
                    v-editable="item"
                    :blok="item"
                    :solution="blok?.solution"
                    :issue="blok?.issue"
                />
            </div>
        </UiContainer> -->
  </section>
</template>
